import React from "react";

export const ChatSvg = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0)">
        <path
          d="M18.2215 6.29099C16.6408 3.06335 13.3342 0.929443 9.6252 0.929443C4.31806 0.929443 0.000421436 5.22259 0.000421436 10.4995C0.000421436 11.9336 0.308305 13.3082 0.915978 14.5897L0.0163351 19.0885C-0.0981778 19.6612 0.407013 20.1673 0.979797 20.054L5.53401 19.1536C6.14721 19.4445 6.78157 19.6657 7.43337 19.8181C5.97232 12.8981 11.2176 6.40244 18.2215 6.29099Z"
          fill="white"
        />
        <path
          d="M27.084 21.5896C27.2412 21.2582 27.3778 20.9204 27.4947 20.5772H27.4647C29.5126 14.5662 25.2059 8.24865 18.848 7.94104C18.8479 7.94071 18.8478 7.94038 18.8477 7.94005C13.3771 7.68795 8.83203 12.0681 8.83203 17.4994C8.83203 22.7719 13.1173 27.0617 18.3881 27.0693C19.8177 27.0674 21.1881 26.7597 22.4659 26.1535C27.4537 27.1396 27.0647 27.0695 27.1793 27.0695C27.6976 27.0695 28.0849 26.5945 27.9836 26.0884L27.084 21.5896Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VerticalDots = () => {
  return (
    <svg
      className="cursor"
      width="6"
      height="22"
      viewBox="0 0 6 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4ZM3 12C3.55228 12 4 11.5523 4 11C4 10.4477 3.55228 10 3 10C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12ZM3 20C3.55228 20 4 19.5523 4 19C4 18.4477 3.55228 18 3 18C2.44772 18 2 18.4477 2 19C2 19.5523 2.44772 20 3 20ZM6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3ZM6 11C6 12.6569 4.65685 14 3 14C1.34315 14 0 12.6569 0 11C0 9.34315 1.34315 8 3 8C4.65685 8 6 9.34315 6 11ZM3 22C4.65685 22 6 20.6569 6 19C6 17.3431 4.65685 16 3 16C1.34315 16 0 17.3431 0 19C0 20.6569 1.34315 22 3 22Z"
        fill="white"
      />
    </svg>
  );
};

export const BackArrow = () => {
  return (
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.24306 2.34317L7.82885 0.928955L0.757812 8.00001L7.82888 15.0711L9.24309 13.6569L3.58623 8L9.24306 2.34317Z"
        fill="white"
      />
    </svg>
  );
};

export const AttachFileSvg = () => {
  return (
    <svg
      className="cursor"
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.93517 11.7796L14.1617 4.55304C15.0392 3.67631 16.4657 3.67631 17.3432 4.55304C18.2206 5.43052 18.2206 6.85774 17.3432 7.73522L7.40091 17.5477C5.9362 19.0124 3.56325 19.0124 2.09854 17.5477C0.633821 16.0837 0.633821 13.7093 2.09854 12.2453L11.9335 2.53784C13.984 0.487387 17.3094 0.487387 19.3569 2.53784C21.4088 4.58904 21.4088 7.91146 19.3584 9.96192L12.239 17.082"
        stroke="#0E5676"
        stroke-opacity="0.4"
        stroke-linecap="round"
      />
    </svg>
  );
};
